import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import CurColorDisplay from './CurColorDisplay';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';

export default class ColorPicker extends Phaser.GameObjects.Container {

  static get COLOR_SELECT() {return 'COLOR_SELECT';}

  static get TOGGLE_PALETTE() {return 'TOGGLE_PALETTE';}

  constructor (scene) {
    super(scene);

    this.curColorDisplay = null;
    this.curSwatchPopUp = null;
    this.colorBtns = null;
    this.colorGroups = null;
    this.closedBg = null;
    this.openBg = null;
    this.arrowIcon = null;
    this.isPaletteOpen = null;

    this.closedBg = ABCyaPhaser.Images.addImage(0,0,'color-select-bg', this).setOrigin(0);
    this.openBg = ABCyaPhaser.Images.addImage(0,0,'color-select-open-bg', this).setOrigin(0);

    this.openBg.x = -this.openBg.getBounds().width + this.closedBg.getBounds().width;
    this.openBg.y = -this.openBg.getBounds().height + this.closedBg.getBounds().height;
    this.openBg.alpha = 0;

    this.curColorDisplay = new CurColorDisplay(this.scene, 38);
    this.curColorDisplay.x = 10;
    this.curColorDisplay.y = 18;
    this.add(this.curColorDisplay);

    this.arrowIcon = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._color_select_arrow, this);
    this.arrowIcon.x = this.closedBg.getBounds().width - (this.arrowIcon.getBounds().width / 2) - 10;
    this.arrowIcon.y = this.closedBg.getBounds().height / 2;

    this.colorGroups = [
      [0xFF5B45,0xCE1515,0x930C23],
      [0xFF9E1F,0xED7600,0xA34D14],
      [0xFFF92E,0xEDA900,0xA86700],
      [0xD8FF36,0x8EBC00,0x568700],
      [0x7CFC29,0x33C116,0x0C910C],
      [0x27E28D,0x00AA71,0x007C5B],
      [0x25DAE8,0x1E9EC1,0x0B7199],
      [0x2473FF,0x243AD3,0x161D93],
      [0xE52EE1,0x9A22AF,0x631782],
      [0xFF52A1,0xD82B9A,0xA8188D],
      [0xFFFFFF,0xBBB4BF,0x88818C],
      [0x645D66,0x403942,0x000000]
    ];

    const totalWidth = this.colorGroups.length * 32;
    const spacing = (this.openBg.getBounds().width - totalWidth) / (this.colorGroups.length + 1);
    this.colorBtns = [];
    let i = 0;
    while (i < this.colorGroups.length) {
      let j = 0;
      while (j < this.colorGroups[i].length) {
        const btn = this.scene.add.rectangle(0, 0, 32, 32, this.colorGroups[i][j], 1).setOrigin(0);
        btn.y = this.openBg.y + 10 + (40 * j);
        btn.x = this.openBg.x + spacing + ((32 + spacing) * i);

        btn.setVisible(false);
        this.add(btn);

        btn.setInteractive();
        btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          this.curColorDisplay.showColor(btn.fillColor);
          const event = this.emit(ColorPicker.COLOR_SELECT, btn.fillColor);
        });

        this.colorBtns.push(btn);
        j++;
      }

      i++;
    }

    this.curColorDisplay.showColor(0x000000);

    this.isPaletteOpen = false;
    this.closedBg.setInteractive();
    this.openBg.setInteractive({ pixelPerfect: true }); // used so that buttons under it can still be pressed

    this.closedBg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.togglePaletteOpen(!this.isPaletteOpen));
    this.openBg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.togglePaletteOpen(!this.isPaletteOpen));

    this.closedText = ABCyaPhaser.Text.addText(100,32, 22, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('color_label'), this, false).setOrigin(0.5);
    this.openText = ABCyaPhaser.Text.addText(99, 36, 22, 0x000000, FontKeys._5x5_Pixel, ABCyaPhaser.Localization.instance.getLocalizedString('color_label'), this, false).setOrigin(0.5)
      .setVisible(false);
  }

  togglePaletteOpen(toOpen) {
    if (this.isPaletteOpen === toOpen) return;
    this.isPaletteOpen = toOpen;

    this.closedBg.alpha = this.isPaletteOpen ? 0 : 1;
    this.openBg.alpha = this.isPaletteOpen ? 1 : 0;
    this.arrowIcon.scaleY = this.isPaletteOpen ? -1 : 1;

    this.openText.setVisible(toOpen);
    this.closedText.setVisible(!toOpen);

    let i = 0;
    while (i < this.colorBtns.length) {
      const btn = this.colorBtns[i];
      if (this.isPaletteOpen === true) {
        btn.setVisible(true);
        btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleColorBtn(btn.fillColor));
      }
      else {
        btn.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handleColorBtn(btn.fillColor));
        btn.setVisible(false);
      }
      i++;
    }

    this.emit(ColorPicker.TOGGLE_PALETTE, this.isPaletteOpen);
  };

  handleColorBtn(color) {
    this.curColorDisplay.showColor(color);

    this.emit(ColorPicker.COLOR_SELECT, color);
  };
}